import { AdvanceType } from '@/models/config'
import { AdvanceTypesService } from '@/services/config'
import { ref, Ref, computed } from '@vue/composition-api'

export default function useAdvanceType () {
  const advanceTypes: Ref<AdvanceType[]> = ref([])

  const getAdvanceTypesActivated = async () => {
    advanceTypes.value = await AdvanceTypesService.getActivated()
  }
  getAdvanceTypesActivated()

  const advanceTypesOp = computed(() => {
    return advanceTypes.value.map(type => {
      return {
        value: type.id,
        text: type.name
      }
    })
  })

  return { advanceTypes, advanceTypesOp, getAdvanceTypesActivated }
}
